<section [attr.aria-labelledby]="titleId()" class="flex h-full w-full items-center justify-center">
  <div
    class="flex w-full max-w-4xl flex-col items-center justify-center gap-(--space-12) px-(--space-6) text-(color:--text-primary) md:flex-row">
    <div class="max-w-md text-center md:text-left">
      <h1 #errorHeading tabindex="-1" [id]="titleId()">
        <span class="block text-5xl font-bold leading-none">{{ code() }}</span>
        <span class="mt-(--space-3) block text-2xl font-light leading-normal md:text-3xl">{{ heading() }}</span>
      </h1>

      <div class="mt-(--space-3)">
        <ng-content />
      </div>

      <div class="mt-(--space-8) flex flex-wrap items-center justify-center gap-(--gap-normal) md:justify-start">
        @if (showBack()) {
          <ces-button-secondary [label]="'common.buttons.back' | transloco" icon="arrow_back" (onClick)="goBack()" />
        }
        <ces-button [label]="'navigation.home' | transloco" icon="home" (onClick)="goHome()" />
      </div>
    </div>

    <img src="img/cesmon.jpg" alt="" class="w-full max-w-sm md:max-w-md" />
  </div>
</section>
